export default __webpack_public_path__ + "static/media/facebook.b2c76dbf.svg";